export default "__VITE_ASSET__BNszzRPO__"